import { useState, useEffect } from 'react';
import { Files } from 'helpers/FileHelpers';
import { MediaList } from 'models/BaseModel';


export const useProfileImage = (fileList: any, setFileList: React.Dispatch<React.SetStateAction<any>>, setProfileUrl: React.Dispatch<React.SetStateAction<string | null>>, setError: (error: string | null) => void) => {
  const [profileImage, setProfileImage] = useState<File | null>(null);
  
  useEffect(() => {
    const loadProfile = async () => {
      if (fileList?.profile) {
        const profileUrl = await Files.Photo.Fetch(fileList.profile, "images");
        if (profileUrl) {
          setProfileUrl(profileUrl);
        }
      }
    };

    loadProfile();
  }, [fileList])

  const handleProfileImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      setProfileImage(event.target.files[0]);
    }
  };

  const handleAttachProfileImage = async () => {
    if (profileImage) {
      const uploadedFile = await Files.Photo.Attach(profileImage, "images", 200, setError);
      setFileList((prevFileList: MediaList) => ({
        ...prevFileList,
        profile: uploadedFile,
      }));
    }
  };

  const handleDeleteProfileImage = () => {
    Files.Photo.Delete(fileList?.profile, "images", setFileList, setProfileUrl);
  };

  return {
    profileImage,
    handleProfileImageChange,
    handleAttachProfileImage,
    handleDeleteProfileImage,
  };
};
